{
  "company": {
    "name": "Automax Automotives",
    "logo": "/assets/images/logo.png",
    "description": "Leading manufacturers of high-quality automotive parts, serving clients globally since 1976."
  },
  "navigation": [
    {
      "name": "Our Product",
      "href": "product"
    },
    {
      "name": "About Us",
      "href": "features"
    },
    {
      "name": "Visit Us",
      "href": "maps"
    }
  ],
  "mainHero": {
    "title": "Manufacturers of",
    "subtitle": "Windsheild Wipers",
    "description": "Manufacturers of High Quality Windsheild Wipers for over 3 Decades. Our range includes Cars, Commercial Vehicles such as Buses and Trucks, Three Wheelers, Trains, Airplanes as well as Ships.",
    "img": "/assets/images/Wiper-1.jpg",
    "primaryAction": {
      "text": "Email us",
      "href": "mailto:sales@automaxautomotives.com?subject=Wiper Purchase Request"
    },
    "secondaryAction": {
      "text": "Call us",
      "href": "tel:+91-9810461336"
    }
  },
  "product": {
    "title": "Windsheild Wiper Blade",
    "items": [
      {
        "title": "High Quality Rubber",
        "description": "Our High Quality Rubber cleans your screen without leaving streaks. Our wipers genlty remove dirt, rain and snow from the windshield enabling you to have clear vision in every weather.",
        "img": "/assets/images/Wiper-2.jpg"
      },
      {
        "title": "Durable All Weather Wiper Blades",
        "description": "Our Wiper Blades are extremly durable able to withstand harshest of weather with ease. ",
        "img": "/assets/images/Wiper-3.jpg"
      },
      {
        "title": "Your Safety is Our Priority",
        "description": "We maintain the highest industrial quality practices to ensure the that your wiper never fail you.",
        "img": "/assets/images/Wiper-temp.jpg"
      }
    ]
  },
  "features": {
    "title": "About Us",
    "subtitle": "Global Exporters of Automotive Parts",
    "description": "Automax Automotives, based in Ghaziabad, Uttar Pradesh, India, has been a trusted name in the automotive industry since 1976. Specializing in the manufacturing of high-quality Windshield Wipers and Sheet Metal Parts, we are committed to delivering excellence to our clients worldwide. With decades of experience and a focus on innovation, we are proud to be a reliable partner for automotive solutions, catering to both domestic and international markets.",
    "items": [
      {
        "name": "MSME Certified",
        "description": "Automax Automotives is an MSME Registered Company, ensuring compliance with government standards and fostering trust among our clients.",
        "icon": "/assets/images/msme.jpeg"
      },
      {
        "name": "Global Exporter",
        "description": "We export high-quality Windshield Wipers and Sheet Metal Parts to clients across the globe, ensuring timely delivery and unmatched quality.",
        "icon": "/assets/images/export.jpg"
      },
      {
        "name": "State-of-the-Art Manufacturing",
        "description": "Our advanced manufacturing facilities in Ghaziabad are equipped with cutting-edge technology to produce durable and reliable automotive parts.",
        "icon": "/assets/images/manufacturing.jpg"
      },
      {
        "name": "Customer-Centric Approach",
        "description": "We prioritize customer satisfaction by offering tailored solutions and maintaining the highest quality standards in all our products.",
        "icon": "/assets/images/customer-focus.jpg"
      }
    ]
  },
  "sheetMetalProducts": {
    "title": "Sheet Metal Parts",
    "subtitle": "Precision-engineered components for diverse industrial applications",
    "items": [
      {
        "name": "Brake Pad Metal Part",
        "img": "/assets/images/sheet_metal_parts/Brake Pad Metal Part.png",
        "description": ""
      },
      {
        "name": "Bush Screw",
        "img": "/assets/images/sheet_metal_parts/Bush Screw.png",
        "description": ""
      },
      {
        "name": "Metal Collar Ring",
        "img": "/assets/images/sheet_metal_parts/Metal Collar Ring.png",
        "description": ""
      },
      {
        "name": "Spanner (Large)",
        "img": "/assets/images/sheet_metal_parts/Spanner Big.png",
        "description": ""
      },
      {
        "name": "Spanner (Small)",
        "img": "/assets/images/sheet_metal_parts/Spanner Small.png",
        "description": ""
      },
      {
        "name": "Sprocket (Large)",
        "img": "/assets/images/sheet_metal_parts/Sprocket Big.png",
        "description": ""
      },
      {
        "name": "Sprocket (Small)",
        "img": "/assets/images/sheet_metal_parts/Sprocket Small.png",
        "description": ""
      },
      {
        "name": "Windshield Wiper Clip",
        "img": "/assets/images/sheet_metal_parts/Windshield Wiper Clip.png",
        "description": ""
      }
    ]
  },
  "maps": {
    "title": "Visit Us",
    "phone": "+91-9810461336"
  }
}